import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MenuComponent } from './components/menu/menu.component';

import { UserAccessGuard } from '@library/modules/user';
import { AuthGuard } from '@library/modules/auth';
import { NavigationGuard } from '@library/modules/navigation';
import {
   TermsViewComponent,
   TermsAgreeComponent
} from '@library/modules/menu';
import { QuotationSelectComponent } from './components/quotation/quotation-select/quotation-select.component';
import { ShipmentSelectComponent } from './components/booking/select';

export const appRoutes: Routes = [
   { path: '',
      component: MenuComponent,
      canActivate: [ AuthGuard ],
      canActivateChild: [ AuthGuard, UserAccessGuard ],
      children: [
         { path: 'terms', component: TermsViewComponent },
         {
            path: 'user',
            loadChildren: () => import( '@library/modules/user' ).then(m => m.UserModule),
            canLoad: [ AuthGuard ],
         },
         {
            path: 'manage',
            loadChildren: () => import('@library/modules/manage/manage.module').then(m => m.ManageModule),
            canLoad: [ AuthGuard ],
            data: { access: ['tracking', 'quoting'], nextRoute: '/create' },
         },
         {
            path: 'create',
            loadChildren: () => import('@library/modules/create/create.module').then(m => m.CreateModule),
            canLoad: [ AuthGuard ],
            data: {
               access: ['booking', 'quoting'], nextRoute: '/invoice',
               routes: [
                  { label: 'shipments', icon: 'shipments', path: '/create/shipment' },
                  { label: 'quotations', icon: 'shipments', path: '/create/quotation' },
               ],
               components: {
                  quote: QuotationSelectComponent,
                  shipment: ShipmentSelectComponent,
               },
               children: [
                  {
                     path: 'shipment',
                     loadChildren: () => import('./components/booking/booking.module').then(m => m.BookingModule),
                     canLoad: [ AuthGuard ],
                     data: { access: 'booking' }
                  },
                  {
                     path: 'quotation',
                     loadChildren: () => import('./components/quotation/quotation.module').then(m => m.QuotationModule),
                     canLoad: [ AuthGuard ],
                     data: { access: 'quoting' }
                  },
               ],
            },
         },
         {
            path: 'invoice',
            loadChildren: () => import('@library/modules/invoices').then(m => m.InvoicesModule),
            canLoad: [ AuthGuard ],
            data: { access: 'invoicing' }
         },
         {
            path: 'template',
            loadChildren: () => import('@library/modules/templates').then(m => m.TemplatesModule),
            canLoad: [ AuthGuard ],
            data: { access: 'booking' }
         },
         {
            path: 'report',
            loadChildren: () => import('@library/modules/reports').then(m => m.ReportsModule),
            canLoad: [ AuthGuard ],
            data: { access: 'tracking' },
         },
         {
            path: 'activityfeed',
            loadChildren: () => import('@library/modules/activityfeed').then(m => m.ActivityfeedModule),
            canLoad: [ AuthGuard ],
            data: { access: 'tracking' },
         },
         {
            path: 'addressbook',
            loadChildren: () => import('@library/modules/addressbook').then(m => m.AddressbookModule),
            canLoad: [ AuthGuard ],
            data: { access: 'booking' }
         },
         { path: 'error', loadChildren: () => import('@library/modules/errors/default.error').then(m => m.DefaultErrorModule) },
      ]
   },
   
   { path: 'termsagree', component: TermsAgreeComponent },
   { path: 'redirect', loadChildren: () => import( '@library/modules/redirect' ).then( m => m.RedirectModule )},
   { path: '', loadChildren: () => import('@library/modules/login').then(m => m.LoginModule), },

   // default
   {
      path: '**',
      component: MenuComponent,
      canActivate: [ NavigationGuard ],
   },
];

@NgModule({
   imports: [ RouterModule.forRoot(
      appRoutes,
      {
         // enableTracing: true,
         // onSameUrlNavigation: 'reload',
         scrollPositionRestoration: 'enabled',
      }
   )],
   exports: [ RouterModule ],
})
export class AppRoutingModule { }
